import { render, staticRenderFns } from "./addField.vue?vue&type=template&id=c66564cc&scoped=true&v-cloak=true"
import script from "./addField.vue?vue&type=script&lang=js"
export * from "./addField.vue?vue&type=script&lang=js"
import style0 from "./addField.vue?vue&type=style&index=0&id=c66564cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66564cc",
  null
  
)

export default component.exports